/** Room-code alphabet: no I/O/0/1, which are unreadable across a living room. */
export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
export const CODE_LENGTH = 4;

export function isRoomCode(value: string): boolean {
  if (value.length !== CODE_LENGTH) return false;
  for (const ch of value) if (!CODE_ALPHABET.includes(ch)) return false;
  return true;
}

export function normalizeRoomCode(value: string): string {
  return value.trim().toUpperCase().replace(/[^A-Z]/g, '').slice(0, CODE_LENGTH);
}

/**
 * An account's referral code: the room-code alphabet, two letters longer.
 * It is typed out of a link rather than read across a room, but it has to be
 * unique across every account, and four letters run out.
 */
export const REFERRAL_CODE_LENGTH = 6;

export function normalizeReferralCode(value: string): string {
  return value.trim().toUpperCase().replace(/[^A-Z]/g, '').slice(0, REFERRAL_CODE_LENGTH);
}

export function isReferralCode(value: string): boolean {
  if (value.length !== REFERRAL_CODE_LENGTH) return false;
  for (const ch of value) if (!CODE_ALPHABET.includes(ch)) return false;
  return true;
}
